import { c as _c } from "react/compiler-runtime";
import { createWallet, loginWithCode, sendLoginCode } from "@opensea/embedded-wallet-sdk";
import { TextBody } from "@opensea/ui-kit";
import { useState } from "react";
import { useTranslations } from "use-intl";
import { UnreachableCaseError } from "../../../lib/errors";
import { EMBEDDED_WALLET_CONNECTOR_ID } from "../../../lib/wagmi";
import { useConnect } from "../../../polychain/hooks";
import { CodeInputStep } from "./CodeInputStep";
import { EmailInputStep } from "./EmailInputStep";
export function ConnectEmbeddedWallet(t0) {
  const $ = _c(11);
  const {
    onChangePaymentMethod
  } = t0;
  const {
    connect,
    getConnectorStrict
  } = useConnect();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      id: "email-input"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [step, setStep] = useState(t1);
  switch (step.id) {
    case "email-input":
      {
        let t2;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <Header />;
          $[1] = t2;
        } else {
          t2 = $[1];
        }
        let t3;
        if ($[2] !== getConnectorStrict) {
          t3 = async t4 => {
            const {
              email
            } = t4;
            const embeddedWalletConnector = getConnectorStrict(EMBEDDED_WALLET_CONNECTOR_ID);
            await embeddedWalletConnector.baseConnector.setup?.();
            await sendLoginCode(email);
            setStep({
              id: "code-input",
              email
            });
          };
          $[2] = getConnectorStrict;
          $[3] = t3;
        } else {
          t3 = $[3];
        }
        let t4;
        if ($[4] !== onChangePaymentMethod || $[5] !== t3) {
          t4 = <>{t2}<EmailInputStep onChangePaymentMethod={onChangePaymentMethod} onSubmit={t3} /></>;
          $[4] = onChangePaymentMethod;
          $[5] = t3;
          $[6] = t4;
        } else {
          t4 = $[6];
        }
        return t4;
      }
    case "code-input":
      {
        let t2;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <Header />;
          $[7] = t2;
        } else {
          t2 = $[7];
        }
        let t3;
        if ($[8] !== connect || $[9] !== getConnectorStrict) {
          t3 = <>{t2}<CodeInputStep onSubmit={async t4 => {
              const {
                code
              } = t4;
              const loginWithCodeResponse = await loginWithCode(code);
              if (typeof loginWithCodeResponse === "string") {
                throw new Error(loginWithCodeResponse);
              }
              if (loginWithCodeResponse.isNewUser) {
                await createWallet();
              }
              await connect(getConnectorStrict(EMBEDDED_WALLET_CONNECTOR_ID));
            }} /></>;
          $[8] = connect;
          $[9] = getConnectorStrict;
          $[10] = t3;
        } else {
          t3 = $[10];
        }
        return t3;
      }
    default:
      {
        throw new UnreachableCaseError(step);
      }
  }
}
export function Header() {
  const $ = _c(9);
  const t = useTranslations("wallet.ConnectEmbeddedWallet");
  let t0;
  if ($[0] !== t) {
    t0 = t("step1");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("step2");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <span className="text-text-secondary">→ {t1}</span>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t0 || $[7] !== t2) {
    t3 = <TextBody className="mb-4 uppercase" size="xs" weight="semibold">{t0}{" "}{t2}</TextBody>;
    $[6] = t0;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}